namespace RedBullMOBILE360.Sms {
    export interface SubscriptionCodesForm {
        OfferId: Serenity.LookupEditor;
        OfferName: Serenity.StringEditor;
        SubscriptionCode: Serenity.StringEditor;
        UnsubscriptionCode: Serenity.StringEditor;
        StopAtrnwCode: Serenity.StringEditor;
        Eligibility: Serenity.LookupEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class SubscriptionCodesForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.SubscriptionCodes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SubscriptionCodesForm.init)  {
                SubscriptionCodesForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(SubscriptionCodesForm, [
                    'OfferId', w0,
                    'OfferName', w1,
                    'SubscriptionCode', w1,
                    'UnsubscriptionCode', w1,
                    'StopAtrnwCode', w1,
                    'Eligibility', w0,
                    'IsActive', w2
                ]);
            }
        }
    }
}
